const DELETE_POSTING_TAG = 'avisos/cancelReservation/DELETE_POSTING_TAG';
const DELETE_POSTING_TAG_COMPLETED = 'avisos/cancelReservation/DELETE_POSTING_TAG_COMPLETED';
const DELETE_POSTING_TAG_FAILED = 'avisos/cancelReservation/DELETE_POSTING_TAG_FAILED';

export { DELETE_POSTING_TAG, DELETE_POSTING_TAG_COMPLETED, DELETE_POSTING_TAG_FAILED };
